import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";
import { DataRouter } from "react-router";

const checkPublicFileExists = async (): Promise<boolean> => {
  try {
    const response = await fetch("/config.json");
    const content = await response.text();
    return !content.includes('<div id="root"></div>');
  } catch {
    return false;
  }
};

async function loadConfig() {
  const configExists = await checkPublicFileExists();

  if (configExists) {
    try {
      const response = await fetch("/config.json");
      return await response.json();
    } catch {
      return process.env;
    }
  }
  return process.env;
}

export function getrestoreOriginalUri(router: DataRouter) {
  return async (_oktaAuth: OktaAuth, originalUri: string | undefined) => {
    router.navigate(toRelativeUrl(originalUri || "/", window.location.origin), {
      replace: true,
    });
  };
}

export function getonAuthRequired(router: DataRouter) {
  return (oktaAuth: OktaAuth) => {
    router.navigate("/login");
  };
}

export const config = await loadConfig();
export const oktaConfig = {
  clientId: config.REACT_APP_OKTA_CLIENT_ID as string,
  issuer: config.REACT_APP_OKTA_ISSUER as string,
  redirectUri: window.location.origin + "/login/callback",
  scopes: [
    "openid",
    "profile",
    "email",
    "front",
    "chatbot:bot:read",
    "chatbot:bot:write",
    "chatbot:bot:delete",
    "chatbot:chat:read",
    "chatbot:chat:write",
    "chatbot:chat:delete",
    "chatbot:chatpdf:write",
    "document_processing:document:read",
    "document_processing:document:update",
    "document_processing:document:create",
    "document_processing:asset:read",
    "document_processing:asset:create",
    "document_processing:asset:update",
    "document_processing:asset:delete",
    "document_processing:config:read",
    "document_processing:config:create",
    "document_processing:config:update",
    "document_processing:config:delete",
    "document_processing:processing:read",
    "document_processing:processing:create",
    "document_processing:processing:update",
    "document_processing:referential:read",
    "document_processing:referential:create",
    "document_processing:referential:update",
    "document_processing:referential:delete",
    "rbac:permission:read",
    "rbac:permission:write",
    "rbac:user:read",
    "rbac:user:write",
    "rbac:user:update",
    "rbac:user:delete",
    "rbac:workspace:read",
    "rbac:workspace:write",
    "rbac:user:workspace:update",
    "rbac:user:role:update",
  ],
  tokenManager: {
    autoRenew: true,
    secure: true,
    storage: "sessionStorage",
  },
};
